<template>
    <div>
        <v-btn
            v-if="!app_is_installed"
            color="primary"
            block
            :large="!dense"
            :disabled="!$rc.$state.isOrganizationAdmin()"
            @click="onClickInstallOrUpdate"
        >
            <v-icon
                size="20"
                class="mr-1"
                aria-hidden="true"
            >
                mdi-download
            </v-icon>
            {{ install_button_text }}
        </v-btn>

        <v-btn
            v-else-if="app_is_update_eligible"
            color="primary"
            block
            :large="!dense"
            :disabled="!$rc.$state.isOrganizationAdmin()"
            @click="onClickInstallOrUpdate"
        >
            <v-icon
                size="20"
                class="mr-1"
                aria-hidden="true"
            >
                mdi-update
            </v-icon>
            Update to Latest Version
        </v-btn>

        <!-- TODO: needs to be dynamic per app. only showing for guest checkin app with graceful fail for now -->
        <!-- likely need to take the same approach as integrations with dynamic links/menu items. will need backend work -->
        <v-btn
            v-else-if="current_app?.app_id === $rc.resolveAppName('red-chirp-guest-check-in')"
            color="primary"
            block
            :large="!dense"
            :to="{ name: 'search-forms-guest-check-in', params: { organization_id: $rc.getOrganizationId() } }"
        >
            Go to App
            <v-icon
                right
                size="20"
                aria-hidden="true"
            >
                mdi-arrow-right
            </v-icon>
        </v-btn>

        <app-install-or-update-dialog
            v-if="current_app"
            v-model="show_install_dialog"
            :app="current_app"
            :is_upgrade="app_is_update_eligible"
            @confirm="onInstallConfirm"
        />
    </div>
</template>

<script>
import AppInstallation from '@/mixins/app-installation.js';
import AppDerived from '@/mixins/app-derived.js';

export default {
    mixins: [AppInstallation, AppDerived],

    components: {
        AppInstallOrUpdateDialog: () => import('@/components/app-store/app-install-or-update-dialog.vue'),
    },

    props: {
        app: {
            type: Object,
            default: function () { return null; }
        },

        app_id: {
            type: String,
            default: function () { return null; }
        },

        text: {
            type: String,
            default: function () { return "Set text variable to change me"; }
        },

        dense: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            show_install_dialog: false,
        }
    },

    computed: {
        install_button_text() {
            if (this.app_has_free_trial) {
                return 'Try For Free';
            }
            return 'Install';
        },
    },

    methods: {
        onClickInstallOrUpdate() {
            this.show_install_dialog = true;
        },

        onInstallConfirm({ app, agreement_specimen }) {
            this.mixinDoAppInstall(() => {
                this.$emit('installed', app);
            }, app.app_id, agreement_specimen);
        },
    },

    mounted() {
        if (this.app_id && !this.app) {
            this.mixinGetAppById(this.app_id, true)
        }
    },
}
</script>

<style lang="scss" scoped></style>